export const config ={
    email_key : "hTqvn0nyrN00PIyRF",
    email_service: "service_1x8ez3l",
    email_template: "template_0wgfar9"
}